import { useEffect } from "react";
import { Helmet } from "react-helmet";
import * as gl from "GlobalConfig";
import { initMatomo, isMatomoEnabled } from "./analytics/matomo";

const HelmetComponent = () => {
  useEffect(() => {
    if (isMatomoEnabled()) {
      initMatomo();
    }
  }, []);


  return (
    <Helmet/>
  );
};

export default HelmetComponent;
